import { render, staticRenderFns } from "./PermissionEmployeeAttendance.vue?vue&type=template&id=445694b6&scoped=true"
import script from "./PermissionEmployeeAttendance.vue?vue&type=script&lang=js"
export * from "./PermissionEmployeeAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445694b6",
  null
  
)

export default component.exports